import { render, staticRenderFns } from "./Withdraw_silpo.vue?vue&type=template&id=74872ee7&scoped=true"
import script from "./Withdraw_silpo.vue?vue&type=script&lang=js"
export * from "./Withdraw_silpo.vue?vue&type=script&lang=js"
import style0 from "./Withdraw_silpo.vue?vue&type=style&index=0&id=74872ee7&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74872ee7",
  null
  
)

/* custom blocks */
import block0 from "./Withdraw_silpo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports